export default {
  getApiJson: 'lua/apis.json',
  getApiClassList:'class/list/list.json',
  getApiTreeList:'class/list/tree.json',
  getApiSortClassList:'class/list/sorted_list.json',
  getApiClassDetailList:'class/list/detail_list.json',
  getApicppenumList:'cppenum/list/sorted_list.json',//获取所有枚举列表
  getApicppenumDetailList:'cppenum/list/detail_list.json',//获取所有枚举详情
  getApicppstructList:'cppstruct/list/sorted_list.json',//获取所有函数类型列表
  getApiglobalfuncList:'globalfunc/list/sorted_list.json',//获取所有全局函数列表
  getApicppstructDetailList:'cppstruct/list/detail_list.json',//获取所有函数类型详情
  getInWhiteList:'/oasis/aiagent/InWhiteList',//获取ai白名单
  report:'api/report',
  search:'api/search',
  feedbackCreate:'v3/feedback.create', // 问题反馈
};
